/* LaBosch Mobile Menu v80 — simple three-view navigation */
(function(){
  'use strict';

  if(!window.matchMedia || !window.matchMedia('(max-width:1024px)').matches) return;

  function init(){
    document.querySelectorAll('[data-lbx80-nav]').forEach(function(nav){
      if(nav.dataset.lbx80Ready==='1') return;
      nav.dataset.lbx80Ready='1';

      var drawer=nav.closest('[data-mg2-mobile-drawer]');
      var body=drawer && drawer.querySelector('.mg2-mobile-drawer__body');
      var panels=Array.prototype.slice.call(nav.querySelectorAll('[data-lbx80-view-panel]'));
      var openers=Array.prototype.slice.call(nav.querySelectorAll('[data-lbx80-open-view]'));
      var backs=Array.prototype.slice.call(nav.querySelectorAll('[data-lbx80-back-main]'));
      var active='main';
      var lastOpener=null;

      if(!panels.length) return;

      function scrollTop(){
        if(body) body.scrollTop=0;
      }

      function showView(name, restoreFocus){
        var found=false;
        try{
          if(document.activeElement && nav.contains(document.activeElement)) document.activeElement.blur();
        }catch(e){}
        panels.forEach(function(panel){
          var isTarget=panel.getAttribute('data-lbx80-view-panel')===name;
          if(isTarget) found=true;
          panel.classList.toggle('is-active',isTarget);
          panel.setAttribute('aria-hidden',isTarget ? 'false' : 'true');
          if(isTarget) panel.removeAttribute('inert');
          else panel.setAttribute('inert','');
        });
        if(!found) return;
        active=name;
        scrollTop();

        if(restoreFocus && lastOpener){
          window.setTimeout(function(){ try{ lastOpener.focus(); }catch(e){} },20);
        }else if(name!=='main'){
          var panel=nav.querySelector('[data-lbx80-view-panel="'+name+'"]');
          var back=panel && panel.querySelector('[data-lbx80-back-main]');
          if(back) window.setTimeout(function(){ try{ back.focus(); }catch(e){} },20);
        }
      }

      openers.forEach(function(button){
        button.addEventListener('click',function(){
          lastOpener=button;
          showView(button.getAttribute('data-lbx80-open-view'),false);
        });
      });

      backs.forEach(function(button){
        button.addEventListener('click',function(){ showView('main',true); });
      });

      if(drawer){
        drawer.addEventListener('click',function(e){
          if(e.target.closest('[data-mg2-mobile-close]')){
            lastOpener=null;
            showView('main',false);
          }
        });
      }

      document.addEventListener('keydown',function(e){
        if(e.key==='Escape' && active!=='main'){
          e.preventDefault();
          e.stopPropagation();
          showView('main',true);
        }
      },true);

      if(drawer && 'MutationObserver' in window){
        var lastHidden=drawer.getAttribute('aria-hidden');
        var mo=new MutationObserver(function(){
          var hidden=drawer.getAttribute('aria-hidden');
          if(hidden!==lastHidden){
            lastHidden=hidden;
            if(hidden==='false'){
              lastOpener=null;
              showView('main',false);
            }
          }
        });
        mo.observe(drawer,{attributes:true,attributeFilter:['aria-hidden']});
      }

      showView('main',false);
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
